import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';

// Green counterpart of the User badge palette (#8da9c4 / #1c2b3a).
// Single source of truth for the home badge color, shared with the event feed.
export const HOME_BADGE_STYLE = { background: '#8dc4a9', color: '#1c3a2b' };

/**
 * The canonical home-name pill: mint-green integration badge with the house
 * icon, as used in the event feed. Use it anywhere a home name is displayed.
 */
function HomeNameBadge({ name, style = {} }) {
    if (!name) return null;
    return (
        <Badge className="integrationBadge" style={{ '--integration-badge-bg': HOME_BADGE_STYLE.background, '--integration-badge-color': HOME_BADGE_STYLE.color, fontSize: '0.75rem', ...style }}>
            <FontAwesomeIcon icon={faHouse} className="me-1" size="xs" />{name}
        </Badge>
    );
}

export default HomeNameBadge;
